export default function PrivacyPolicy() {
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Information We Collect</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-medium text-gray-700">1.1 Personal Information</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Name, email address, and phone number</li>
              <li>User type (supplier or celebrant)</li>
              <li>Business information (for suppliers)</li>
              <li>Wedding details and preferences (for celebrants)</li>
            </ul>

            <h3 className="text-lg font-medium text-gray-700">1.2 Usage Information</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Platform usage patterns and interactions</li>
              <li>Exhibit attendance and participation</li>
              <li>Service bookings and inquiries</li>
              <li>Communication preferences</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. How We Use Your Information</h2>
          <div className="space-y-3">
            <p className="text-gray-700 leading-relaxed">
              We use your information to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Provide and improve our platform services</li>
              <li>Facilitate connections between suppliers and celebrants</li>
              <li>Organize and manage wedding supplier exhibits</li>
              <li>Send important updates about exhibits and services</li>
              <li>Provide customer support and assistance</li>
              <li>Analyze platform usage to improve user experience</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Information Sharing</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-medium text-gray-700">3.1 With Other Users</h3>
            <p className="text-gray-700 leading-relaxed">
              We may share your information with other platform users to facilitate connections:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Supplier profiles are visible to celebrants</li>
              <li>Celebrant preferences may be shared with relevant suppliers</li>
              <li>Contact information is shared when you initiate communication</li>
            </ul>

            <h3 className="text-lg font-medium text-gray-700">3.2 With Third Parties</h3>
            <p className="text-gray-700 leading-relaxed">
              We do not sell your personal information. We may share information with:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Service providers who assist in platform operations</li>
              <li>Legal authorities when required by law</li>
              <li>Business partners for joint marketing (with your consent)</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Data Security</h2>
          <p className="text-gray-700 leading-relaxed">
            We implement appropriate security measures to protect your personal information against 
            unauthorized access, alteration, disclosure, or destruction. However, no method of 
            transmission over the internet is 100% secure.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Your Rights</h2>
          <div className="space-y-3">
            <p className="text-gray-700 leading-relaxed">
              You have the right to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Access and review your personal information</li>
              <li>Correct inaccurate or incomplete information</li>
              <li>Request deletion of your account and data</li>
              <li>Opt out of marketing communications</li>
              <li>Withdraw consent for data processing</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Cookies and Tracking</h2>
          <p className="text-gray-700 leading-relaxed">
            We use cookies and similar technologies to enhance your experience, analyze usage patterns, 
            and provide personalized content. You can control cookie settings through your browser preferences.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Data Retention</h2>
          <p className="text-gray-700 leading-relaxed">
            We retain your personal information for as long as necessary to provide our services, 
            comply with legal obligations, resolve disputes, and enforce our agreements. You may 
            request deletion of your data at any time.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Children's Privacy</h2>
          <p className="text-gray-700 leading-relaxed">
            Our platform is not intended for users under 18 years of age. We do not knowingly collect 
            personal information from children. If we become aware of such collection, we will take 
            steps to delete the information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Changes to This Policy</h2>
          <p className="text-gray-700 leading-relaxed">
            We may update this Privacy Policy from time to time. We will notify you of any material 
            changes by email or through our platform. Your continued use of our services constitutes 
            acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Contact Us</h2>
          <p className="text-gray-700 leading-relaxed">
            If you have questions about this Privacy Policy or our data practices, please contact us at:
          </p>
          <div className="mt-3 p-4 bg-gray-50 rounded-lg">
            <p className="text-gray-700">
              <strong>Email:</strong> 
              <a href="mailto:privacy@philtrade.com" className="text-orange-600 hover:text-orange-700 ml-1">
                privacy@philtrade.com
              </a>
            </p>
            <p className="text-gray-700 mt-2">
              <strong>Address:</strong> PhilTrade Privacy Team, [Your Business Address]
            </p>
          </div>
        </section>
      </div>
    </div>
  )
}
